<div style="margin-top: 20px;">
  <h2>内訳</h2>
  <div>
    <table mat-table id="gasDetailUchiwakeTbl" multiTemplateDataRows [dataSource]="gasDetailUchiwake"
      style="width: 100%; border: solid 1px rgba(0, 0, 0, 0.12);">
      <ng-container matColumnDef="itemAname">
        <th mat-header-cell class="border-bottom-double" style="width: 18%; font-weight: bold;" *matHeaderCellDef>項目
        </th>
        <td mat-cell id="itemAname" class="border-bottom-double" style="width: 18%; font-weight: bold;"
          *matCellDef="let e">{{
          e.itemAname
          }}</td>
      </ng-container>
      <ng-container matColumnDef="meisaiInfText01">
        <th mat-header-cell class="border-bottom-double" style="width: 18%; font-weight: bold;" *matHeaderCellDef>期間
        </th>
        <td mat-cell id="meisaiInfText01" class="border-bottom-double" style="width: 18%"
          *matCellDef="let e">
          <div *ngIf="e.meisaiOutj=='000' && e.meisaiInfDivcd=='2'">
            <ng-container *ngIf="e.meisaiInfText01?.indexOf(' ') < 0 && e.meisaiInfText01?.indexOf('　') < 0">
              {{ e.meisaiInfText01 ? (e.meisaiInfText01 | slice:0:4) + '/' + (e.meisaiInfText01 | slice:4:6) + '/' + (e.meisaiInfText01 | slice:6:8) + '～' +
            (e.meisaiInfText01 | slice:9:13) + '/' + (e.meisaiInfText01 | slice:13:15) + '/' + (e.meisaiInfText01 | slice:15:17) : ''}}
            </ng-container>
            <ng-container *ngIf="e.meisaiInfText01?.indexOf(' ') >= 0 || e.meisaiInfText01?.indexOf('　') >= 0">
              {{ e.meisaiInfText01 ? (e.meisaiInfText01 | slice:0:4) + '/' + (e.meisaiInfText01 | slice:4:6) + '/' + (e.meisaiInfText01 | slice:6:8) + ' ～ ' +
            (e.meisaiInfText01 | slice:11:15) + '/' + (e.meisaiInfText01 | slice:15:17) + '/' + (e.meisaiInfText01 | slice:17:19) : ''}}
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="meisaiInf03">
        <th mat-header-cell class="border-bottom-double" style="width: 13%; font-weight: bold;" *matHeaderCellDef>単価
        </th>
        <td mat-cell id="meisaiInf03" class="border-bottom-double table-cell-type-num" style="width: 13%"
          *matCellDef="let e">
          <div *ngIf="e.meisaiInfDivcd=='1'">
            <div *ngIf="prdClsfyDiv=='32'">
              {{e.meisaiInf03 | number:'1.4-4'}}{{e.hyojiUnit03}}
            </div>
            <div *ngIf="prdClsfyDiv !='32'">
              {{e.meisaiInf03 | number:'1.2-2'}}{{e.hyojiUnit03}}
            </div>        
          </div>
          <div *ngIf="e.meisaiInfDivcd=='2'">
            <ng-container *ngIf="e.meisaiInfText03?.includes('.')">
              {{ e.meisaiInfText03.split('.')[0] | number:'1.0-0' }}.{{ e.meisaiInfText03.split('.')[1] }}
              </ng-container>
            <ng-container *ngIf="!e.meisaiInfText03?.includes('.')">
              {{ e.meisaiInfText03 }}
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="meisaiInf02">
        <th mat-header-cell class="border-bottom-double" style="width: 13%; font-weight: bold;" *matHeaderCellDef>日数・使用量
        </th>
        <td mat-cell id="meisaiInf02" class="border-bottom-double table-cell-type-num" style="width: 13%"
          *matCellDef="let e">
          <div *ngIf="e.meisaiInfDivcd=='1'">
            {{e.meisaiInf02}}{{e.hyojiUnit02}}
          </div>
          <div *ngIf="e.meisaiInfDivcd=='2'">
            {{e.meisaiInfText02}}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="meisaiInf01">
        <th mat-header-cell class="border-bottom-double" style="width: 13%; font-weight: bold;" *matHeaderCellDef>金額
        </th>
        <td mat-cell id="meisaiInf01" class="border-bottom-double table-cell-type-num" style="width: 13%"
          *matCellDef="let e">
          <div *ngIf="e.meisaiOutj!='000'">
            <div *ngIf="e.meisaiInfDivcd=='1'">
              <div *ngIf="prdClsfyDiv=='32'">
                {{e.meisaiInf01 | number:'1.4-4'}}{{e.hyojiUnit01}}
              </div>
              <div *ngIf="prdClsfyDiv !='32'">
                {{e.meisaiInf01 | number:'1.2-2'}}{{e.hyojiUnit01}}
              </div>        
            </div>
            <div *ngIf="e.meisaiInfDivcd=='2'">
              {{e.meisaiInfText01}}
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row class="border-bottom-double" *matHeaderRowDef="displayedColumns;">
      </tr>
      <tr mat-row class="border-bottom-double" *matRowDef="let row; columns: displayedColumns" class="mat-row">
      </tr>
    </table>

    <!-- カスタマイズポイント -->
    <ng-template #extension_point></ng-template>

    <!--  延滞利息が0でないときのみボタン活性 -->
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-card-actions *ngIf="urikakekinInfo.cdtmnySyosaiInfDto.delayRisoku != 0" class="btn_area_left">
        <button type="button" mat-raised-button color="primary" class="btn" (click)="onClick()">延滞利息照会</button>
      </mat-card-actions>
    </div>
  </div>
</div>